"use client";

import { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import "../RecentAds.css"; // Import or create a CSS file for styling
import "../../../../components/CustomButton.css";
import { Row, Col, Button, Spinner } from "reactstrap";
import { Link, useNavigate } from "react-router-dom";
import DownloadAds from "../DownloadAds";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import {
  FaAngleDoubleDown,
  FaAngleDoubleUp,
  FaCaretDown,
  FaChevronDown,
  FaSlidersH,
} from "react-icons/fa";
import { fetchGurdwaras, fetchItemsBySubCatID } from "../../Data";
import {
  Dropdown,
  DropdownToggle,
  DropdownItem,
  DropdownMenu,
} from "reactstrap";
import Tooltip from "@mui/material/Tooltip";
import { toast } from "react-toastify";
import {
  setSelectedSubCategory,
  setSelectedItem,
  setActiveTab,
  setRadius,
  setSortBy,
  setCurrentPage,
  setSearchQuery,
  setSearchText,
} from "../../../../redux/slices/LcaSlice";
import { RiArrowDownDoubleFill } from "react-icons/ri";
import PostAdModal from "../../modals/PostAdModal";
import { Fade, Menu, MenuItem, Modal } from "@mui/material";
import LcaAndBwv from "./LcaAndBwv";
import GurdwaraDropdown from "./GurdwaraDropdown";
import { useLocation } from "react-router-dom";
import { setOnlineView } from "../../../../redux/slices/LcaAndBwvSlice";
import AdsFlashingMenu from "./AdsFashingMenu";
import AdsDropDownPopUp from "../../WeddingVendors/AdsDropDownPopUp";

const RecentAds = ({
  handleClear,
  productSubCat,
  scrollPopupVisible,
  setScrollPopupVisible,
  setToggled, // Accept setToggled prop
}) => {
  const dispatch = useDispatch();
  const islogin = useSelector((state) => state.user.isLogin);
  const userinfo = useSelector((state) => state.user.userInfo);
  const { totalRecords, onlineView } = useSelector(
    (state) => state.lcaAndVendors
  );
  const enabled = onlineView;
  const user = islogin ? JSON.parse(userinfo) : null;
  const { selectedSubCategory, selectedItem } = useSelector(
    (state) => state.lcAds
  );
  const [fetechingItems, setFetchingItems] = useState(false);
  const navigate = useNavigate();
  const [by, setBy] = useState("");
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggleDropdown = () => setDropdownOpen(!dropdownOpen);
  const [showPopup, setShowPopup] = useState(false);
  const [openPostAd, setOpenPostAd] = useState(false);
  const popupRef = useRef();
  const isAdmin = user && user.Role === "admin";
  const togglePostAd = () => setOpenPostAd((prevState) => !prevState);
  const scrollPopupRef = useRef();
  const [items, setItems] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [currentMenu, setCurrentMenu] = useState(null);
  const location = useLocation();
  const [dropdownAnchor, setDropdownAnchor] = useState(null);
  const dropdownRef = useRef(null);
  const [position, setPosition] = useState({ top: 180, left: 0 });
  const [showTooltip, setShowTooltip] = useState(false);
  const [isMobile, setIsMobile] = useState(
    typeof window !== "undefined" ? window.innerWidth < 820 : false
  );
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const subcategoryName = searchParams.get("subcategory");
    const itemName = searchParams.get("item");

    if (subcategoryName && productSubCat.length > 0) {
      const matchingCategory = productSubCat.find(
        (category) => category && category.Name === subcategoryName
      );
      if (
        matchingCategory &&
        (!selectedSubCategory || selectedSubCategory.id !== matchingCategory.id)
      ) {
        dispatch(setSelectedSubCategory(matchingCategory));
        setCurrentMenu(matchingCategory.id);
        if (matchingCategory.id === 63) {
          dispatch(setActiveTab("Vendor"));
        } else {
          dispatch(setActiveTab("Customers"));
        }
      }
    }

    if (itemName && items.length > 0) {
      const matchingItem = items.find(
        (item) => item && item.subCatItemName === itemName
      );
      if (
        matchingItem &&
        (!selectedItem || selectedItem.itemId !== matchingItem.itemId)
      ) {
        dispatch(setSelectedItem(matchingItem));
      }
    }
  }, [
    location.search,
    productSubCat,
    items,
    selectedSubCategory,
    selectedItem,
  ]);

  const [hasCategoryId, setHasCategoryId] = useState(false);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 820);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (!isMobile) return;
    setShowTooltip(true);
    const timer = setTimeout(() => setShowTooltip(false), 5000);
    return () => clearTimeout(timer);
  }, [isMobile]);

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const item = searchParams.get("item");
    const subcategory = searchParams.get("subcategory");
    setHasCategoryId(item || subcategory);
  }, [location.search]);

  const handleSubCategoryClick = (category, event) => {
    setShowPopup(false);
    console.log("Subcategory clicked:", category);
    const rect = event.currentTarget.getBoundingClientRect();
    setDropdownAnchor({
      top: rect.bottom + window.scrollY,
      left: rect.left + window.scrollX,
      width: rect.width,
    });
    setCurrentMenu(category.id);
    setSelectedSubCategory(category);
    setScrollPopupVisible(true);
    dispatch(setRadius(15));
    setAnchorEl(event.currentTarget);

    const searchParams = new URLSearchParams(location.search);

    if (selectedSubCategory && selectedSubCategory.id === category.id) {
      dispatch(setSelectedSubCategory(null));
      dispatch(setActiveTab("Customers"));
      setAnchorEl(null);
      setCurrentMenu(null);
      searchParams.delete("subcategory");
      searchParams.delete("item");
    } else {
      dispatch(setSelectedSubCategory(category));
      searchParams.set("subcategory", category.Name || "");
      searchParams.delete("item");
      if (category.id === 63) {
        dispatch(setActiveTab("Vendor"));
      } else {
        dispatch(setActiveTab("Customers"));
      }
    }

    dispatch(setSelectedItem(null));
    navigate(
      { pathname: location.pathname, search: searchParams.toString() },
      { replace: true }
    );
  };

  const handleToggleStatus = () => {
    dispatch(setOnlineView(!enabled));
  };
  const fetchItems = async () => {
    setFetchingItems(true);
    const items = await fetchItemsBySubCatID(selectedSubCategory?.id);
    setItems(items);
    setFetchingItems(false);
  };

  useEffect(() => {
    if (selectedSubCategory) {
      fetchItems();
    }
  }, [selectedSubCategory]);

  const handleItemClick = (item, ev) => {
    console.log("handleItemClick called with item:", item); // Debug log
    ev.preventDefault();
    ev.stopPropagation();
    if (!item) return;
    dispatch(setSearchQuery(""));
    dispatch(setSearchText(""));
    dispatch(setCurrentPage(1));
    const searchParams = new URLSearchParams(location.search);
    const isCurrentlySelected =
      selectedItem && selectedItem.subCatItemId === item.subCatItemId;
    if (isCurrentlySelected) {
      dispatch(setSelectedItem(null));
      searchParams.delete("item");
      if (selectedSubCategory) {
        searchParams.set("subcategory", selectedSubCategory.Name || "");
      }
    } else {
      dispatch(setSelectedItem(item));
      searchParams.set("item", item.subCatItemName || "");
      if (selectedSubCategory) {
        searchParams.set("subcategory", selectedSubCategory.Name || "");
      }
    }
    navigate(
      {
        pathname: location.pathname,
        search: searchParams.toString(),
      },
      { replace: true }
    );
    setDropdownAnchor(null);
  };

  useEffect(() => {
    if (!dropdownAnchor) return;
    function handle(e) {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        console.log("Clicked outside dropdown, closing...");
        setDropdownAnchor(null);
      } else {
        console.log("Clicked inside dropdown, keeping it open...");
      }
    }
    document.addEventListener("mousedown", handle);
    return () => document.removeEventListener("mousedown", handle);
  }, [dropdownAnchor]);
  useEffect(() => {
    if (dropdownAnchor && dropdownRef.current) {
      const dropdownWidth = dropdownRef.current.offsetWidth;
      const viewportWidth = window.innerWidth;

      let newLeft = dropdownAnchor.left;

      if (newLeft + dropdownWidth > viewportWidth) {
        newLeft = viewportWidth - dropdownWidth - 10;
      }

      setPosition({
        top: 180,
        left: newLeft,
      });
    }
  }, [dropdownAnchor]);
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownAnchor(null);
        setCurrentMenu(null);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const customOrderMap = {
    16: 1,
    17: 2,
    18: 3,
    63: 4,
    19: 5,
    23: 6,
    24: 7,
  };
  const sortedProductSubCat = [...productSubCat].sort((a, b) => {
    return (
      (customOrderMap[a.id] || Number.POSITIVE_INFINITY) -
      (customOrderMap[b.id] || Number.POSITIVE_INFINITY)
    );
  });
  const displayNameMap = {
    18: "Child Care",
    63: "Weddings",
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        setShowPopup(false);
      }
    };
    if (showPopup) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showPopup]);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        scrollPopupRef.current &&
        !scrollPopupRef.current.contains(event.target)
      ) {
        setScrollPopupVisible(false);
      }
    };
    if (scrollPopupVisible) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [scrollPopupVisible]);
  useEffect(() => {
    const timer = setTimeout(() => {
      setShowPopup(true);
    }, 100);
    return () => clearTimeout(timer);
  }, []);
  const screenWidth = window.innerWidth;
  const Popup = ({ closePopup }) => (
    <div className="text-center wc_show_cat_popup d-lg-block d-xl-none d-block">
      <div
        // ref={popupRef}
        style={{
          position: "relative",
          padding: "10px",
          backgroundColor: "rgb(246 225 107)",
          display: "flex",
          borderRadius: "8px",
          boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
          zIndex: 5,
          width: "210px",
          margin: "10px auto",
        }}
      >
        <div
          style={{
            fontSize: "14px",
            fontWeight: "bold",
            textWrap: "nowrap",
            // marginBottom: "15px",
          }}
        >
          Select an AD type to view
        </div>
        <div
          style={{
            marginTop: "-4px",
            textAlign: "center",
            // marginBottom: "-9px",
            cursor: "pointer",
          }}
        >
          <RiArrowDownDoubleFill size={23} />
        </div>
      </div>
    </div>
  );
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 250) {
        setVisible(false);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  const ScrollPopup = ({ visible, closePopup }) => {
    return (
      <div
        style={{
          position: "fixed",
          bottom: "8%",
          left: "50%",
          transform: "translateX(-50%)",
          padding: "7px 20px",
          backgroundColor: "var(--theme-light)",
          color: "var(--white)",
          animation: "flashingRed 2s infinite",
          borderRadius: "8px",
          boxShadow: "0 4px 8px var(--theme-shadow)",
          zIndex: 9,
          display: visible ? "block" : "none",
          cursor: "pointer",
        }}
        onClick={closePopup}
      >
        <div
          style={{
            fontSize: "16px",
            fontWeight: "bold",
            whiteSpace: "nowrap",
          }}
        >
          Scroll
          {/* <span className="text-warning">
            &nbsp;UP <FaAngleDoubleUp />
          </span>
          / */}
          <span className="text-warning">
            &nbsp;DOWN <FaAngleDoubleDown />
          </span>
          &nbsp;to see new listings
        </div>
      </div>
    );
  };
  const open22 = Boolean(anchorEl);
  const tooltipText = enabled ? "Enable Online View" : "Disable Online View";
  return (
    <div className="recent-ads-container">
      <ScrollPopup visible={visible} closePopup={() => setVisible(false)} />
      {/* <AdsFlashingMenu
        sortedProductSubCat={sortedProductSubCat}
        handleSubCategoryClick={handleSubCategoryClick}
        handleItemClick={handleItemClick}
        dropdownAnchor={dropdownAnchor}
        currentMenu={currentMenu}
        position={position}
        dropdownRef={dropdownRef}
        fetechingItems={fetechingItems}
        displayNameMap={displayNameMap}
        open22={open22}
        items={items}
      /> */}
      <Row
        style={{
          display: "flex",
          alignItems: "center",
        }}
        className="px-3 text-nowrap py-1"
        id="filters"
      >
        <Col
          style={{
            display: "flex",
            alignItems: "center",
            flexBasis: "33%",
            padding: "0px",
          }}
          id="finalProducts"
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",

              width: "100%", // Ensure the div takes full width of the column
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                gap: "5px",
              }}
            >
              <div
                className="show-results inter-font fw-semibold"
                style={{
                  color: "var(--button-text)",
                  // backgroundColor: "var(--theme-lighter)",
                  border: "1px solid var(--theme-border)",
                  borderRadius: "5px",
                  padding: "3px 12px",
                  fontSize: "15px",
                  fontWeight: "bold",
                  marginRight: "5px",
                }}
              >
                {totalRecords || "Loading"} results
              </div>
              {hasCategoryId && (
                <div onClick={handleClear}>
                  <div
                    // style={{
                    //   color: "var(--theme-primary)",
                    //   // backgroundColor: "var(--theme-lighter)",
                    //   border: "1px solid var(--theme-primary)",
                    //   borderRadius: "10px",
                    //   padding: "6px 8px",
                    //   cursor: "pointer",
                    //   fontSize: "13px",
                    //   fontWeight: "bold",
                    // }}
                    title={"Clear Results"}
                    className="custom-btn custom-btn-default "
                  >
                    clear X
                  </div>
                </div>
              )}
              {isAdmin && (
                <div className={`custom-btn custom-btn-default me-2`}>
                  <DownloadAds />
                </div>
              )}
            </div>
            <div
              className="toggle-wrapper-status ms-2"
              style={{ position: "relative", display: "inline-block" }}
            >
              <Tooltip
                title={tooltipText}
                placement="top"
                arrow
                open={isMobile ? showTooltip : undefined}
                disableHoverListener={isMobile}
                slotProps={{
                  popper: {
                    modifiers: [
                      {
                        name: "zIndex",
                        enabled: true,
                        phase: "write",
                        fn: ({ state }) => {
                          state.styles.popper.zIndex = 50;
                        },
                      },
                    ],
                  },
                }}
              >
                <span
                  onClick={handleToggleStatus}
                  onMouseEnter={() => !isMobile && setShowTooltip(true)}
                  onMouseLeave={() => !isMobile && setShowTooltip(false)}
                  className="toggle-button-eye"
                  style={{ cursor: "pointer" }}
                >
                  {enabled ? (
                    <FaEye size={24} color="green" />
                  ) : (
                    <FaEyeSlash size={24} color="gray" />
                  )}
                </span>
              </Tooltip>
            </div>
          </div>
          <div className="d-block d-lg-none">
            <AdsDropDownPopUp />
          </div>
        </Col>
        <Col
          className="p-0 m-0 d-none d-lg-flex align-items-center"
          style={{
            display: "flex",
            alignItems: "center",
            // justifyContent: "flex-end",
          }}
        >
          <GurdwaraDropdown />
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 8,
            }}
          >
            <div className=" ">
              <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown}>
                <DropdownToggle
                  style={{
                    backgroundColor: "var(--white)",
                    color: "var(--text-primary)",
                    border: "1px solid var(--theme-border)",
                    width: "140px",
                  }}
                  className="wd_filter-btn py-1"
                >
                  {by.charAt(0).toUpperCase() + by.slice(1) || "Sort By"}
                  <FaCaretDown style={{ color: "var(--theme-dark)" }} />
                </DropdownToggle>
                <DropdownMenu style={{ color: "var(--white)", width: "140px" }}>
                  <DropdownItem
                    onClick={() => {
                      dispatch(setSortBy(""));
                      setBy("");
                    }}
                  >
                    Sort By
                  </DropdownItem>
                  <DropdownItem
                    onClick={() => {
                      dispatch(setSortBy("DESC"));
                      setBy("Newer to Older");
                    }}
                  >
                    Newer to Older
                  </DropdownItem>
                  <DropdownItem
                    onClick={() => {
                      dispatch(setSortBy("ASC"));
                      setBy("Older to Newer");
                    }}
                  >
                    Older to Newer
                  </DropdownItem>
                </DropdownMenu>
              </Dropdown>
            </div>
          </div>
        </Col>
      </Row>
      {/* {isAdmin && (
        <div className="lca-download-ads-mobile mb-2 d-block d-md-block d-lg-block d-xl-none">
          <DownloadAds />
        </div>
      )} */}
      <div
        className=""
        style={{
          backgroundColor: "#eae9e9",
          padding: "10px",
          borderRadius: "7px",
        }}
      >
        {" "}
        <Row className="m-0 p-0 d-flex align-items-center justify-content-between">
          <Col
            sm={9}
            className="community-message"
            style={{
              textAlign: "left",
              padding: "7px",
              color: "black",
              fontWeight: "500",
              fontSize: "18px", // default size
            }}
          >
            This site is FREE to use with purpose to serve the Sikh Community.
          </Col>
          <Col sm={3}>
            <button
              type="button"
              className="btn m-0 fw-semibold"
              style={{
                height: "100%",
                width: "100%",
                padding: "0.5rem",
                borderRadius: "20px",
                boxShadow: "0 4px 6px var(--theme-shadow)",
                whiteSpace: "nowrap",
                backgroundColor: "var(--button-bg)",
                color: "var(--white)",
                // hover effect
                transition: "background-color 0.3s ease",
                "&:hover": {
                  backgroundColor: "var(--button-bg-hover)",
                },
              }}
              onClick={() => setOpenPostAd(true)}
            >
              Post Your Ad
            </button>
          </Col>
          <PostAdModal open={openPostAd} toggle={togglePostAd} />
        </Row>
      </div>
      <LcaAndBwv scrollPopupVisible={scrollPopupVisible} />
    </div>
  );
};

export default RecentAds;
